export default __webpack_public_path__ + "static/media/01.427985f5.svg";